import React, { useEffect, useState } from 'react';
import api from '../services/api';
import '../styles/CustomerPage.css';
import CustomerModal from '../modals/CustomerModal';

export default function Customers() {
    const [customers, setCustomers] = useState([]);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editCustomer, setEditCustomer] = useState(null);
    const [companyFilter, setCompanyFilter] = useState('');

    useEffect(() => {
        loadCustomers();
    }, []);

    const loadCustomers = () => {
        api.get('/Company')
            .then(res => {
                setCustomers(res.data);
                setFilteredCustomers(res.data);
            })
            .catch(() => alert('Fehler beim Laden der Kunden.'));
    };

    const handleAdd = () => {
        setEditCustomer(null);
        setShowModal(true);
    };

    const handleEdit = (customer) => {
        setEditCustomer(customer);
        setShowModal(true);
    };

    const handleDelete = (id) => {
        if (window.confirm('Kunde wirklich löschen?')) {
            api.delete(`/Company/${id}`)
                .then(loadCustomers)
                .catch(() => alert('Fehler beim Löschen.'));
        }
    };

    const handleModalSave = () => {
        setShowModal(false);
        loadCustomers();
    };

    useEffect(() => {
        let filtered = customers;

        if (companyFilter) {
            filtered = filtered.filter(c =>
                c.name.toLowerCase().includes(companyFilter.toLowerCase())
            );
        }

        setFilteredCustomers(filtered);
    }, [companyFilter, customers]);

    return (
        <div className="customer-container">
            <h2>Kunden</h2>

            <div className="filter-container">
                <input
                    type="text"
                    placeholder="Firma suchen..."
                    value={companyFilter}
                    onChange={e => setCompanyFilter(e.target.value)}
                    className="input_filter"
                />
                <button className="button" onClick={handleAdd}>Kunde hinzufügen</button>
            </div>

            <div className="table-wrapper-customer">
                <table className="table">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Adresse</th>
                        <th>Kommentar</th>
                        <th>Ansprechpartner</th>
                        <th>Aktionen</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filteredCustomers.map(c => (
                        <tr key={c.id}>
                            <td>{c.name}</td>
                            <td>{c.address}</td>
                            <td>{c.comment}</td>
                            <td>{c.contactPerson}</td>
                            <td>
                                <button className="button-warning" onClick={() => handleEdit(c)}>Bearbeiten</button>
                                <button className="button-danger" onClick={() => handleDelete(c.id)}>Löschen</button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            {showModal && (
                <CustomerModal
                    customer={editCustomer}
                    onClose={() => setShowModal(false)}
                    onSave={handleModalSave}
                />
            )}
        </div>
    );
}
